import style from './style.module.css';
import InfoCard from '@/components/InfoCard';
import { StaticImageData } from 'next/image';

interface CardGridProps {
  title: string;
  cards: CardData[];
  pageType: 'CreditCardPage' | 'LoanPage';
}

export interface CardData {
  id: string;
  imageCard: StaticImageData | string;
  title: string;
  texts: { label: string; value: string }[];
  labelButton: string;
  linkButton: string;
  variant?: 'primary' | 'secondary';
  countryCode: string;
  slug: string;
}

const CardGrid = ({ title, cards, pageType }: CardGridProps) => {
  return (
    <div className={style.containerCardGrid}>
      <h3 className={style.titleCardGrid}>{title}</h3>
      <div className={style.contentCardGrid}>
        {cards.map((card, index) => (
          <InfoCard
            id={card.id}
            key={index}
            imageCard={card.imageCard}
            title={card.title}
            texts={card.texts}
            labelButton={card.labelButton}
            countryCode={card.countryCode}
            variant={card.variant}
            cardSlug={card.slug}
            pageType={pageType}
          />
        ))}
      </div>
    </div>
  );
};

export default CardGrid;
